import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import './categories.scss';

const scrollIndicatorVariants = cva('categories__scroll-indicator', {
    variants: {
        side: {
            left: 'categories__scroll-indicator--left',
            right: 'categories__scroll-indicator--right',
        },
    },
    defaultVariants: {
        side: 'left',
    },
});

type Props = ComponentPropsWithRef<'button'> & VariantProps<typeof scrollIndicatorVariants>;
export const CategoriesScrollIndicator = ({ side, ...props }: Props) => {
    return (
        <div
            className={scrollIndicatorVariants({ side })}
            data-testid="categories-scroll-indicator"
            data-side={side}
            aria-label={side === 'right' ? 'Scroll categories right' : 'Scroll categories left'}
        >
            <Button data-testid="categories-scroll-indicator-button" {...props}>
                <Icon name="arrow-left" />
            </Button>
        </div>
    );
};
